var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.52 225.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #246370;\n        stroke-width: 15px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #72b7a4;\n        stroke-dasharray: 0 0 28.34 28.34;\n        stroke-width: 9px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "161.39 112.2 112.76 64.89 64.13 112.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.76,64.89v95.75"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 112.76,
    cy: 112.76,
    r: 108.26
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubir);
export default __webpack_public_path__ + "static/media/SUBIR.26e10ffc1ee1cdeb458aa8c240f36cfc.svg";
export { ForwardRef as ReactComponent };